import React from "react";
import "./Servicos.css";

const Servicos = () => {
  return (
    <section id="servicos" className="servicos-section">
      <div className="container">
        <h2>Como posso te ajudar</h2>
        <div className="divider"></div>
        <p className="servicos-intro">
          Minha consultoria é um processo profundo e personalizado. Abaixo estão
          os pilares do meu trabalho, que podem ser combinados para criar uma
          experiência única para você.
        </p>

        <div className="servicos-grid">
          <div className="servico-item">
            <h3>Análise de Coloração</h3>
            <p>
              Revelamos as cores que mais valorizam sua beleza natural, criando
              uma paleta pessoal para roupas, acessórios e maquiagem.
            </p>
          </div>
          <div className="servico-item">
            <h3>Consultoria de Estilo</h3>
            <p>
              Juntas, identificamos e refinamos seu estilo pessoal, garantindo
              que suas roupas comuniquem exatamente quem você é.
            </p>
          </div>
          <div className="servico-item">
            <h3>Revitalização de Guarda-Roupa</h3>
            <p>
              Otimizamos seu closet de forma estratégica, criando dezenas de
              novos looks com as peças que você já possui.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Servicos;
